import angular from 'angular';

// Filter to allow using a dynamic filter name (i.e. in an ng-repeat list where different
// items use different filters)
module.exports = angular.module('common.filters.use-filter', [
])
.filter('useFilter', function($filter) {
  return function(value, childFilterArgs) {
    let args = childFilterArgs.split(':');
    let filter = $filter(args.shift());
    args.unshift(value);
    return filter.apply(null, args);
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/use-filter.js
 **/